module.exports = __webpack_public_path__ + "img/2.04c0b50f.png";